import { Modal as ModalModule, UI, Utils } from 'common';
import React, { useContext } from 'react';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Session, Util } = Utils;
const { Typography, Fineprint, Link } = UI;

const ReactivatePlanModal = ({ data: { onConfirm }, modalId }) => {
	const { closeModal } = useContext(ModalContext);

	const handleReactivate = () => {
		onConfirm();
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const handleCancel = () => {
		closeModal(modalId, ModalButtonActionType.Cancel);
	};

	const contactPhoneNumber = Util.getFraudNumber();

	return (
		<Modal
			modalId={modalId}
			className="account-reactivate-plan-modal"
			header="Confirm Account Reactivation"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'Reactivate',
				onClick: handleReactivate,
			}}
			secondaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Cancel',
				onClick: handleCancel,
			}}
			size="small"
			dataqa="reactivate-plan-modal"
		>
			<div className="body">
				<Typography.P>
					Clicking Confirm will instantly reactivate your account. You'll
					continue with your existing plan and billing cycle.
				</Typography.P>
				<Fineprint type="information" dataqa="reactivate-plan-fineprint">
					<Link
						href={'https://help.stamps.com/hc/en-us/articles/20821937508379'}
						target="_blank"
					>
						Learn more about your subscriptions, plans, and billing cycles
					</Link>
					, or contact support with your questions at {contactPhoneNumber},
					Monday-Friday 8 am - 8 pm Central Time.
				</Fineprint>
			</div>
		</Modal>
	);
};

export default ReactivatePlanModal;
